import { render, staticRenderFns } from "./Full.vue?vue&type=template&id=63237047&"
import script from "./Full.vue?vue&type=script&lang=ts&"
export * from "./Full.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63237047')) {
      api.createRecord('63237047', component.options)
    } else {
      api.reload('63237047', component.options)
    }
    module.hot.accept("./Full.vue?vue&type=template&id=63237047&", function () {
      api.rerender('63237047', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/message/Full.vue"
export default component.exports